import * as React from 'react';
import type { SVGProps } from 'react';
const SvgReport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#report_svg__a)">
      <path
        fill="#263E6A"
        d="M12 16.423q.261 0 .438-.177a.6.6 0 0 0 .177-.438.6.6 0 0 0-.177-.439.6.6 0 0 0-.438-.177.6.6 0 0 0-.438.177.6.6 0 0 0-.177.439q0 .261.177.438a.6.6 0 0 0 .438.177m-.5-2.961h1V7.384h-1zM8.673 20 4 15.336V8.673L8.664 4h6.663L20 8.664v6.663L15.336 20zm.427-1h5.8l4.1-4.1V9.1L14.9 5H9.1L5 9.1v5.8z"
      />
    </g>
    <defs>
      <clipPath id="report_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReport;
